<template>
  <div class="leftOne">
    <commonHeader title="手动监测统计"></commonHeader>
    <div class="mainContent">
      <img src="./content_bg.png" class="bg" />
      <section class="top">
        <div class="top_left">
          <img src="./total.png" />
        </div>
        <div class="top_right">
          <span class="title">
            <span class="name">设备总数量</span>
            <span class="num">{{ data.totalDeviceNum || 0 }}</span>
            <span class="unit">台</span>
          </span>
          <div class="line"></div>
          <div class="info">
            <div class="info_item">
              <img src="./zidong.png" />
              <span>自动设备：{{ data.autoDeviceNum || 0 }}</span>
            </div>
            <div class="info_item">
              <img src="./shoudong.png" />
              <span>手动设备：{{ data.handDeviceNum || 0 }}</span>
            </div>
          </div>
        </div>
      </section>
      <ul class="detail">
        <li class="detail_item">
          <div class="item_left">
            <img src="./unit.png" />
          </div>
          <div class="item_right">
            <div class="num">
              <span>{{ data.handUnitNum || 0 }}</span
              >/{{ data.totalUnitNum || 0 }}
            </div>
            <div class="item_name">
              <span>单位占比</span>
              <img src="./arrow.png" />
            </div>
          </div>
        </li>
        <li class="detail_item">
          <div class="item_left">
            <img src="./area.png" />
          </div>
          <div class="item_right">
            <div class="num">
              <span>{{ data.handAreaNum || 0 }}</span
              >/{{ data.totalAreaNum || 0 }}
            </div>
            <div class="item_name">
              <span>片区占比</span>
              <img src="./arrow.png" />
            </div>
          </div>
        </li>
        <li class="detail_item">
          <div class="item_left">
            <img src="./report.png" />
          </div>
          <div class="item_right">
            <div class="num">
              <span>{{ data.reportNum || 0 }}</span
              >/{{ data.totalReportNum || 0 }}
            </div>
            <div class="item_name">
              <span>报备占比</span>
              <img src="./arrow.png" />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import commonHeader from '../commonHeader.vue'
  export default {
    name: 'left1',
    props: {
      areaId: {
        type: Number | String
      }
    },
    watch: {
      areaId: {
        handler(val) {
          this.getData()
          this.startTimer()
        },
        immediate: true
      }
    },
    components: {
      commonHeader
    },
    data() {
      return {
        data: {},
        timer: null
      }
    },
    methods: {
      getData() {
        this.$axiospost('operation/automatic/hand/detection/queryLeftOneStatics', {
          parentAreaId: this.areaId
        }).then(res => {
          if (res.data.status == 10000) {
            this.data = res.data.data
          }
        })
      },
      // 新增：启动定时器
      startTimer() {
        this.stopTimer() // 先清除可能存在的定时器
        this.timer = setInterval(() => {
          this.getData()
        }, 5 * 60 * 1000) // 5分钟 = 300000毫秒
      },
      // 新增：停止定时器
      stopTimer() {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.stopTimer)
    }
  }
</script>

<style lang="less" scoped>
  .bg(@img) {
    background: url('./@{img}') no-repeat;
    background-size: 100% 100%;
  }
  .leftOne {
    height: 26.34vh;

    .mainContent {
      margin-left: 0.18rem;
      margin-top: 0.93vh;
      height: 19.94vh;
      position: relative;

      .bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
      }

      .top {
        padding: 0.74vh 0.12rem 0.74vh 0.08rem;
        height: 9.18vh;
        display: flex;
        justify-content: space-between;

        &_left {
          width: 0.85rem;
          height: 9.18vh;
          font-size: 0;

          img {
            width: 0.85rem;
            height: auto;
          }
        }

        &_right {
          margin-left: 0.22rem;
          flex: 1;
          padding-top: 1vh;

          .title {
            font-family: MicrosoftYaHei;
            font-size: 1.11vh;
            color: #fff;
            display: inline-block;
            background: url('./total_num.png') no-repeat;
            background-size: 66% 65%;
            padding-left: 0.05rem;
            background-position: 0 1.48vh;

            .num {
              padding-left: 0.1rem;
              padding-right: 0.07rem;
              vertical-align: -0.28vh;
              font-family: Alibaba-PuHuiTi-H;
              font-size: 2.23vh;
              font-weight: bold;
              color: #4abdff;
            }
          }

          .line {
            margin: 0.93vh 0;
            height: 0.93vh;
            .bg('line.png');
          }

          .info {
            display: flex;
            justify-content: space-between;
            font-family: HiraginoSansGB-W3;
            font-size: 1.11vh;
            color: #bcbcbc;
            padding-right: 0.22rem;

            div {
              img {
                width: 0.09rem;
                height: auto;
              }

              &:last-child {
                color: #30ea87;
              }
            }
          }
        }
      }

      .detail {
        padding: 3.6vh 0.1rem 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &_item {
          display: flex;
          align-items: center;

          .item_left {
            width: 0.58rem;
            font-size: 0;
            margin-right: 0.02rem;

            img {
              width: 0.58rem;
              height: auto;
            }
          }

          .item_right {
            margin-left: 0.02rem;
            display: flex;
            flex-direction: column;
            align-items: center;

            .num {
              font-family: MicrosoftYaHei;
              font-size: 1.3vh;
              color: #fff;
              font-weight: bold;

              span {
                font-size: 1.67vh;
                color: #3b9cff;
              }
            }

            .item_name {
              margin-top: 1.02vh;
              width: 0.78rem;
              height: 1.76vh;
              .bg('./name_bg.png');
              font-size: 1.11vh;
              font-family: MicrosoftYaHei;
              color: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pumpMonitor/leftOne/index.vue